/** Tokens JWT en localStorage (recordar) o sessionStorage (sesión estricta). */

const TOKEN_KEY = "vf_access_token";
const REFRESH_KEY = "vf_refresh_token";
const PERSIST_FLAG_KEY = "vf_session_persistent";

function storageForPersistent(persistent) {
  return persistent ? localStorage : sessionStorage;
}

function readPair(persistent) {
  const store = storageForPersistent(persistent);
  return {
    access: store.getItem(TOKEN_KEY) || "",
    refresh: store.getItem(REFRESH_KEY) || "",
  };
}

function writePair(persistent, access, refresh) {
  const primary = storageForPersistent(persistent);
  const secondary = storageForPersistent(!persistent);
  secondary.removeItem(TOKEN_KEY);
  secondary.removeItem(REFRESH_KEY);
  if (access) primary.setItem(TOKEN_KEY, access);
  else primary.removeItem(TOKEN_KEY);
  if (refresh) primary.setItem(REFRESH_KEY, refresh);
  else primary.removeItem(REFRESH_KEY);
  try {
    localStorage.setItem(PERSIST_FLAG_KEY, persistent ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export const tokenStore = {
  isPersistent() {
    try {
      return localStorage.getItem(PERSIST_FLAG_KEY) === "1";
    } catch {
      return false;
    }
  },

  get() {
    const persistent = this.isPersistent();
    const primary = readPair(persistent);
    if (primary.access) return primary.access;
    if (!persistent) {
      try {
        return localStorage.getItem(TOKEN_KEY) || "";
      } catch {
        return "";
      }
    }
    return "";
  },

  getRefresh() {
    const persistent = this.isPersistent();
    const primary = readPair(persistent);
    if (primary.refresh) return primary.refresh;
    if (!persistent) {
      try {
        return localStorage.getItem(REFRESH_KEY) || "";
      } catch {
        return "";
      }
    }
    return "";
  },

  set(access, refresh, { remember = false } = {}) {
    writePair(!!remember, access || "", refresh || "");
  },

  clear() {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(REFRESH_KEY);
      localStorage.removeItem(PERSIST_FLAG_KEY);
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(REFRESH_KEY);
    } catch {
      /* ignore */
    }
  },
};
